
<div class="grid grid-cols-3 gap-3 items-center mb-5">
  <div class="flex justify-end">
    <i
      class="pvsc-icon icon-left-arrow cursor-pointer justify-self-end"
      (click)="monthChange(-1)"
      [ngClass]="{'hidden': selectedIndex === 0}"></i>
  </div>

  <div class="text-color-blue1 text-3xl justify-self-center">
    {{monthsLocalized[selectedMonth] | titlecase}}, {{currentMonthlyResult.year}}
  </div>

  <div>
    <i
      class="pvsc-icon icon-right-arrow cursor-pointer"
      (click)="monthChange(1)"
      [ngClass]="{'hidden': selectedIndex === 11}"></i>
  </div>
</div>
